var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"kraken-title-wrapper"},[_c('h2',{staticClass:"kraken-title"},[_c('span',{staticClass:"kraken-title-textparent"},[_vm._v(" "+_vm._s(_vm.titleText)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }